export default "__VITE_ASSET__2f3466cb__"